import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-settings3-icon',
  templateUrl: './general-settings3.component.html'
})
export class GeneralSettings3Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
